<template>  
<div id="menus-dropdown-comparator" class="center-element d-flex justify-content-center">
    <div class="wrapper d-flex justify-content-center align-items-center w-100 gap-3 mb-3 flex-wrap">
    <div class="dropdown-1">
        <IndicatorDropDown 
        :data="data"
        :dataOpport="dataOpport"
        :title="'Indicator'" 
        :queryTitle="'Select Indicator'" 
        :titleV="'false'" 
        :push="false"
        :defaultIndicator="'overallcountryrisk'"
        @getIndicatorFromDropDown="handleDataFromChildID"
        @submit="selectIndicator"
        />
    </div>
    <span class="material-icons">compare_arrows</span>
    <div class="dropdown" v-if="regions.length > 0 && country.length > 0">
        <MenuDropDown
        ref="menuDropDownRef"
        :data="regions"
        :dataorg="regionsorg"
        :data_country="country"
        :title="'Region'" 
        :queryTitle="'Select Region'" 
        :path="path" 
        :push="false"
        @submit="selectRegion"
        />
    </div>
    </div>
</div>

<div class="center-verticaly d-flex flex-column align-items-center justify-content-center" v-if="has_error">
    <AlertMessage @ERROR="error" :message="errorMessage" :type="'warning'"/>
</div>
<div class="center-verticaly d-flex flex-column align-items-center justify-content-center"  v-if="regions.length > 0 && Object.keys(countriesData).length > 0">
    <ComparisonBar style="max-width:100%; max-height:40rem" :id="'Criteria-Comparison-Bar'" :regions="regions" :regionsSelected="selectedRegions" :countriesData="countriesData" :IndicatorSelected="selectedIndicator" :key="selectedIndicator+'-'+selectedRegions"/>
</div>
</template>
  
  <script>
  /* eslint-disable */
  import IndicatorName from '@/views/app.json'
  import IndicatorOpportName from '@/views/app_opport.json'
  import ComparisonBar from './ComparisonBar.vue'
  import MenuDropDown from '../UI/MenuDropDownMul'
  import IndicatorDropDown from '../UI/MenuDropDownIndicator'
  import AlertMessage from '../UI/AlertMessage.vue'
  import api from '@/services/api'
  
  export default {
    components: {
      'MenuDropDown': MenuDropDown,
      ComparisonBar,
      IndicatorDropDown,
      AlertMessage
    },
    data() {
      return {
        regions: [],
        regionsorg: [],
        country: [],
        path: 'country-comparison',
        countriesData : {},
        data: IndicatorName,
        dataOpport: IndicatorOpportName,
        selectedIndicator: 'overallcountryrisk',
        selectedRegions: 'Western Europe',
        indicatorSave: '',
        regionSave: '',
        receivedDataId: this.$route.params.indicator,
        receivedDataRe: this.$route.params.region,
        has_error: false,
        errorMessage: 'Please select an Indicator and a Region',
        tabs: [
          {name: 'Single Criteria', code: 'single'},
          {name: 'Opportunity VS Risk', code: 'opportvsrisk'},
        ],
        selected: "single"
      }
    },
    methods: {
      select(code){
        this.selected = code
      },
      selectIndicator(id){
        this.selectedIndicator = id
      },
      selectRegion(region){
        this.selectedRegions = region.join(',')
      },
      triggerComparison() {
        // Call the methods that handle data from children
        this.$refs.menuDropDownRef.notifyChild();
  
        // Check if both receivedDataId and receivedDataRe are defined
        if (this.receivedDataId !== undefined && this.receivedDataRe !== undefined) {
          // Update the route and reload the page
          this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
            window.location.reload();
          });
        }
      },
      error(data) {
        this.has_error = data
      },
      compare() {
        if (this.receivedDataId == '' || this.receivedDataRe == '') {
          this.has_error = true;
        } else { 
            this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
            window.location.reload()
          });
        }
      },
      async getRegions() {
        try {
          const response = await api.get('/regions');
          const data = await response.data;
          this.regions = data.data.map(item => [item.name]).filter(item => item[0] !== 'World');;
        } catch (error) {
          console.error('Error retrieving regions:', error);
        }
      },
      async getRegionsOrg() {
        try {
          const response = await api.get('/regions?isorg=1');
          const data = await response.data;
          this.regionsorg = data.data.map(item => [item.name]);
        } catch (error) {
          console.error('Error retrieving regions:', error);
        }
      },
      async getAllCountries() {
        try {
          const response = await api.get('/countries?cnttype=REG');
          const data = await response.data;
          this.country = data.data.map(item => [item.country_name]);
        } catch (error) {
          console.error('Erreur lors de la récupération des pays :', error);
        }
      },
      async getCountries() {
          try {
              const response = await api.get('/countries');
              const data = await response.data;
  
              this.countriesData  = data
          } catch (error) {
              console.error('Error retrieving countries:', error);
          }
      },
    },
    mounted() {
      this.getRegions();
      this.getRegionsOrg();
      this.getCountries()
      this.getAllCountries()
    }
  }
  </script>